import { HTTP } from '@/lib/http/client';
import AppConfig from '@/models/appConfig';

export default class AppConfigApi {
  static async getConfig(): Promise<AppConfig> {
    const res = await HTTP.get('config');
    return res.data;
  }
}
